export const createSettingsTermsAndConditionsRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
